import { Fragment, PropsWithChildren, ReactElement } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

type SignupBuilderMiddlewareProps = PropsWithChildren;

// Define the signup flow sequence
const SIGNUP_FLOW = [
  '/signup/company-info', // Step 1
  '/signup/subscription', // Step 2
];

export const SignupBuilderMiddleware = (
  props: SignupBuilderMiddlewareProps,
): ReactElement => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isFromUserInfo = searchParams.get('fromUserInfo') === 'true';
  const accessToken = localStorage.getItem('access_token');

  // Access token check - redirect authenticated users away from signup
  // Exception: Allow authenticated users to access subscription step if coming from user info
  if (accessToken && !isFromUserInfo) {
    return <Navigate to="/home" replace />;
  }

  // Check if user is trying to access a step they shouldn't have access to yet
  const currentStepIndex = SIGNUP_FLOW.findIndex((path) =>
    location.pathname.includes(path),
  );

  if (currentStepIndex > 0) {
    // User is trying to access step 2 or later
    const hasCompletedPreviousStep = sessionStorage.getItem(
      `signup_step_${currentStepIndex - 1}`,
    );

    // Special case: Allow access to subscription step if coming from useUserInfo
    // This happens when authenticated users have incomplete subscriptions
    const isSubscriptionStep = location.pathname.includes(
      '/signup/subscription',
    );

    if (!hasCompletedPreviousStep && !(isSubscriptionStep && isFromUserInfo)) {
      // Redirect to the first step if they haven't completed the flow
      // (unless it's the subscription step coming from useUserInfo)
      return <Navigate to="/signup/company-info" replace />;
    }
  }

  return <Fragment>{props.children}</Fragment>;
};
